'use client';
import { Button } from '@/components/ui/button';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { Tabs, TabsContent } from '@/components/ui/tabs';
import useMixPanel from '@/hooks/useMixPanel';
import { TCategoryServices, Service } from '@/services/api/services-api';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasicCard from '../../cards/basic-card/BasicCard';
import BasicTabsList from '../../tab/BasicTabsList';
import { useRootStore } from '@/providers/root-store-provider';

const ChooseService: React.FC<{ services: TCategoryServices[] }> = ({
  services
}) => {
  // i18n text
  const { t } = useTranslation('newBooking');
  const Mixpanel = useMixPanel();
  const continueRef = useRef<null | HTMLDivElement>(null);
  const addStep = useRootStore((store) => store.addStep);
  const [selectedTab, setSelectedTab] = useState(services[0].sport.id);
  const [selectedService, setSelectedService] = useState<Service>();
  const loadStepServicesData = useRootStore(
    (store) => store.loadStepServicesData
  );
  return (
    <>
      <h2 className="font-bold mb-6">{t('stepServiceTitle')}</h2>
      <Tabs
        value={selectedTab}
        onValueChange={(value) => setSelectedTab(value)}
      >
        <ScrollArea>
          <BasicTabsList services={services} />
          <ScrollBar orientation="horizontal" />
        </ScrollArea>
        {services.map((category) => (
          <TabsContent
            key={category.sport.id}
            value={category.sport.id}
            className="grid grid-cols-1 gap-3 md:grid-cols-2 items-stretch"
          >
            {category.services.map((service) => (
              <BasicCard
                key={service.id}
                service={service}
                selectedService={selectedService}
                setSelectedService={setSelectedService}
              />
            ))}
          </TabsContent>
        ))}
      </Tabs>
      <div ref={continueRef}>
        <Button
          onClick={() => {
            Mixpanel.track('press continue button', {
              screen: 'New Booking'
            });
            if (selectedService) {
              loadStepServicesData({
                service: selectedService
              });
              addStep(1);
            }
          }}
          type="button"
          className="w-full mt-9"
          disabled={!selectedService}
        >
          {t('stepParticipants.form.continue')}
        </Button>
      </div>
    </>
  );
};

export default ChooseService;
